import { render } from "./aCardWhite.vue?vue&type=template&id=102c068f&ts=true"
import script from "./aCardWhite.vue?vue&type=script&lang=ts"
export * from "./aCardWhite.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__